<div
  class="main d-flex flex-column align-items-center light-theme"
  [ngClass]="{ 'bg justify-content-center':  !isMobile(), 'bg-none justify-content-start':  isMobile(), 'main-padding': isSmallScreen()  }"
>
  @if (isMobile()) {
    <div class="header-mobile"></div>
  }
  <div #mainContainer class="main-container mx-auto" [ngClass]="{'main-container-mobile': isMobile()}">
    <div class="content-container" [ngClass]="{'content-container-mobile': isMobile()}">
      <header class="logo-container">
        <img src="{{assetPath}}imgs/noggin-logo.svg" width="135" height="48" alt="Noggin - a Motorola Solutions Company" />
      </header>
      <main class="w-100">
        <div class="w-100">
          <div class="form d-flex flex-column align-items-center align-self-stretch w-100" [ngClass]="isMobile()? 'gap-5xl': 'gap-2xl'">
            <div class="page-not-found-img">
              <img  src="{{assetPath}}imgs/page-not-found.svg" alt="Page not found image"/>
            </div>
            <div class="content-body d-flex flex-column align-items-center align-self-stretch" [ngClass]="isMobile()? 'gap-xl': 'gap-2xl'">
              <div class="message d-flex flex-column align-items-center align-self-stretch">
                <p class="text-center font-text-xl-semibold text-primary-900" i18n="@@pageNotFound.message">Whoops…</p>
              </div>
              <div class="message-details d-flex flex-column align-items-center align-self-stretch">
                <p class="text-center" i18n="@@pageNotFound.messageDetails">
                  It looks like you’re lost. You may have an old link or maybe the page was moved.
                </p>
              </div>
            </div>
          </div>
          @if (isMobile()) {
            <div class="privacy-text-mobile text-center">
              <p i18n="@@pageNotFound.messageDetails">
                © {{currentYear}} Noggin. All rights reserved.<br/> <a class="text-tertiary-600" href="https://www.noggin.io/cookie-policy" target="_blank">Cookie Policy</a> and
                <a class="text-tertiary-600" href="https://www.noggin.io/privacy" target="_blank">Privacy Policy</a>
              </p>
            </div>
          }
        </div>
      </main>
    </div>
  </div>
  @if (!isMobile()) {
    <div #privacyText class="privacy-text text-center">
      <p>
        © {{currentYear}} Noggin. All rights reserved. <a href="https://www.noggin.io/cookie-policy" target="_blank">Cookie Policy</a> and
        <a href="https://www.noggin.io/privacy" target="_blank">Privacy Policy</a>
      </p>
    </div>
  }
</div>

